module.exports = __webpack_public_path__ + "img/img-04.37337383.jpg";